<template>
    <div>
        <div class="operation-btns">
            <el-button type="primary" @click="autoDispatchOrderClick" v-if="auth_control.have_auto_dispatch_auth">自动派单设置</el-button>
            <a v-if="auth_control.have_export_auth" :href="exportUrl" class="exportBtn" @click="exportOrderClick">导出excel</a>
            <!-- <el-button
        type="primary"
        @click="toAddOrder"
        v-if="auth_control.have_add_auth"
      >新建订单</el-button> -->
        </div>
        <div class="filter-wrap">
            <div class="filter-item">
                <span>选择日期：</span>
                <el-date-picker
                    v-model="dateValue"
                    type="datetimerange"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    range-separator="～"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    @change="dateChange"
                ></el-date-picker>
            </div>
            <el-select v-model="selectted_project" placeholder="请选择服务项目" class="filter-item" @change="selectChange" clearable>
                <el-option v-for="item in service_project" :key="item.uuid" :label="item.server_name" :value="item.uuid"></el-option>
            </el-select>
            <el-input v-model="search_value" placeholder="请输入手机号或订单搜索" class="searchInput" clearable></el-input>
            <el-button type="primary" @click="searchOrder">搜索</el-button>
        </div>
        <div class="order-type-wrap">
            <span :class="{ order_type: true, active: order_type === '1' }" @click="orderTypeClick('1')">全部</span>
            <span :class="{ order_type: true, active: order_type === '2' }" @click="orderTypeClick('2')">待处理</span>
            <span :class="{ order_type: true, active: order_type === '3' }" @click="orderTypeClick('3')">处理中</span>
            <span :class="{ order_type: true, active: order_type === '4' }" @click="orderTypeClick('4')">待确认</span>
            <span :class="{ order_type: true, active: order_type === '5' }" @click="orderTypeClick('5')">已完成</span>
            <span :class="{ order_type: true, active: order_type === '6' }" @click="orderTypeClick('13')">已撤回</span>
            <span :class="{ order_type: true, active: order_type === '7' }" @click="orderTypeClick('7')">已驳回</span>
            <span :class="{ order_type: true, active: order_type === '10' }" @click="orderTypeClick('10')">退款中</span>
            <span :class="{ order_type: true, active: order_type === '8' }" @click="orderTypeClick('8')">已退款</span>
            <!-- <span :class="{order_type: true, active: order_type === '9'}" @click="orderTypeClick('9')">已关闭</span> -->
            <span :class="{ order_type: true, active: order_type === '11' }" @click="orderTypeClick('11')">未解决</span>
            <span :class="{ order_type: true, active: order_type === '12' }" @click="orderTypeClick('12')">回收站</span>
        </div>
        <div class="table-wrap">
            <el-table :data="tableData" border style="width: 100%">
                <el-table-column prop="order_code" label="订单编号" align="center"></el-table-column>
                <el-table-column prop="create_time" label="下单时间" align="center"></el-table-column>
                <el-table-column label="下单用户昵称" align="center">
                    <template slot-scope="scope">
                        <span v-if="scope.row.order_tag === '2'">后台管理员</span>
                        <span v-else>{{ scope.row.user_name }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="是否追加费用" align="center">
                    <template slot-scope="scope">
						<span v-if="scope.row.order_append_price > 0">是</span>
						<span v-else>否</span>
                    </template>
                </el-table-column>
                <el-table-column prop="order_total_price" label="订单金额(元)" align="center"></el-table-column>
                <el-table-column prop="order_total_price" label="佣金" align="center">
                    <template slot-scope="scope">
                        <span v-if="scope.row.status !== '2'">{{ scope.row.commission_price }}</span>
                    </template>
                </el-table-column>

                <el-table-column label="支付方式" align="center">
                    <template slot-scope="scope">
                        <span>{{ scope.row.pay_type | filterPay}}</span>
                    </template>
                </el-table-column>

                <el-table-column prop="server_name" label="服务项目" align="center"></el-table-column>
                <!-- <el-table-column
          label="订单类型"
          align="center"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.order_tag === '1'">线上订单</span>
            <span v-if="scope.row.order_tag === '2'">线下订单</span>
          </template>
        </el-table-column> -->
                <el-table-column label="处理人员" align="center" width="60">
                    <template slot-scope="scope">
                        <span v-if="!scope.row.salesman_name">等待分配业务员</span>
                        <span v-else>{{ scope.row.salesman_name }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="user_mobile" label="用户手机号" align="center" width="80"></el-table-column>
                <el-table-column label="订单状态" align="center" width="60">
                    <template slot-scope="scope">
                        <span v-if="scope.row.order_status === '1'">待支付</span>
                        <span v-if="scope.row.order_status === '2'">待处理</span>
                        <span v-if="scope.row.order_status === '3'">处理中</span>
                        <span v-if="scope.row.order_status === '4'">待确认</span>
                        <span v-if="scope.row.order_status === '5'">已完成</span>
                        <span v-if="scope.row.order_status === '6'">已撤单</span>
                        <span v-if="scope.row.order_status === '7'">已取消</span>
                        <span v-if="scope.row.order_status === '8'">已驳回</span>
                        <span v-if="scope.row.order_status === '9' && scope.row.order_tag === '2'">已关闭</span>
                        <span v-if="scope.row.order_status === '9' && scope.row.order_tag === '1'">已退款</span>
                        <span v-if="scope.row.order_status === '10'">退款中</span>
                        <span v-if="scope.row.order_status === '11'">未解决</span>
						<span v-if="scope.row.order_status === '13'">已撤回</span>
                    </template>
                </el-table-column>
              <el-table-column label="备注信息" align="center">
                  <template slot-scope="scope">
                      <div class="remarks-wrap">
                          <div
                              :class="{
                                  remarks_box: true,
                                  yellow: scope.row.remarks_colour === '1',
                                  red: scope.row.remarks_colour === '2',
                                  green: scope.row.remarks_colour === '3'
                              }"
                          ></div>
                          <div>{{ scope.row.remarks }}</div>
                      </div>
                  </template>
              </el-table-column>
				<el-table-column prop="after_sale_type" label="售后特权" align="center" width="160">
					<template slot-scope="scope">
					    <span v-if="scope.row.after_sale_type === '1'">除处理费用外，商家还同意消费者申请退货退款</span>
					    <span v-if="scope.row.after_sale_type === '2'">除处理费用外，商家还愿意额外支付消费者补偿款，最大允许补偿金额:¥{{scope.row.compensation_price}}</span>
						 <span v-if="scope.row.after_sale_type === '3'">除处理费用外，商家还同意消费者不退货仅退款</span>
						  <span v-if="scope.row.after_sale_type === '4'">其他：{{scope.row.other_sale_massage}}</span>
					</template>
					
				</el-table-column>
                <el-table-column label="跟进记录" align="left"  width="160">
                    <template slot-scope="scope">
						<span v-for='(item,index) in scope.row.followList' :key="index" >{{scope.row.followList.length -  index  }}.{{item.content}} <br/> </span>
                    </template>
                </el-table-column>
                <el-table-column label="需要管理员协助" align="center" width="70">
                    <template slot-scope="scope">
                        <span v-if="scope.row.is_admin === '1'">否</span>
                        <span v-else>是</span>
                    </template>
                </el-table-column>
                <el-table-column label="操作" align="center" width="100">
                    <template slot-scope="scope">
                        <div class="operation-wrap">
                            <span class="operation-item" @click="toRemarkClick(scope.row)" v-if="auth_control.have_remark_auth">备注</span>

                            <span class="operation-item" @click="toContactRemark(scope.row)" v-if="auth_control.have_remark_auth">联系方式</span>
                            <span class="operation-item" @click="toOrderFollowClick(scope.row)" v-if="auth_control.have_follow_record_auth">进度</span>
                            <span class="operation-item" @click="recallOrderDelete(scope.row)"
                                  v-if="(scope.row.user_is_del == 2 || scope.row.work_is_del == 2) && auth_control.have_recall_order_auth"
                            >
                                 撤销删除
                            </span>
                            <span class="operation-item" @click="delOrder(scope.row)" v-if="auth_control.have_delete_order_auth && (scope.row.order_status==9 || scope.row.order_status==5)">
                              删除
                            </span>
                            <span
                                class="operation-item"
                                v-if="
                                    auth_control.have_dispatch_order_auth &&
                                        ((scope.row.order_status === '2' && !scope.row.salesman_name) ||
                                            scope.row.order_status === '8' ||
                                            scope.row.order_status === '6' ||
                                            scope.row.order_status === '10' ||
                                            scope.row.order_status === '11'||
                                            scope.row.order_status === '13')
                                "
                                @click="dispatchOrderClick(scope.row)"
                            >
                                派单
                            </span>
                            <span
                                class="operation-item"
                                v-if="auth_control.have_widthdraw_order_auth && (scope.row.order_status === '8' || scope.row.order_status === '6'|| scope.row.order_status === '13')"
                                @click="cancelOrderClick(scope.row)"
                            >
                                撤单
                            </span>
                            <span
                                class="operation-item"
                                v-if="
                                    auth_control.have_widthdraw_order_auth &&
                                        ((scope.row.order_status === '2' && !!scope.row.salesman_name) || scope.row.order_status === '3' || scope.row.order_status === '4')
                                "
                                @click="recallOrderClick(scope.row)"
                            >
                                撤回
                            </span>
                            <span class="operation-item" v-if="auth_control.have_sucess_handle_auth && scope.row.order_status === '3'" @click="succHandleClick(scope.row)">
                                成功
                            </span>
                            <span
                                class="operation-item"
                                v-if="auth_control.have_close_order_auth && (scope.row.order_status === '6' && scope.row.order_tag === '2')"
                                @click="closeOrderClick(scope.row)"
                            >
                                关闭订单
                            </span>
                            <span class="operation-item" v-if="auth_control.have_close_order_auth && scope.row.order_status === '11'" @click="refoundClick(scope.row)">即退</span>
                            <span class="operation-item" v-if="auth_control.have_close_order_auth && scope.row.order_status === '10'" @click="refoundClick(scope.row)">同意</span>
                            <span class="operation-item" v-if="auth_control.have_close_order_auth && scope.row.order_status === '10'" @click="refuseRefoundClick(scope.row)">
                                拒绝
                            </span>
                            <span
                                class="operation-item"
                                v-if="auth_control.have_confirm_complete_auth && (scope.row.order_status === '4' && scope.row.order_tag === '2')"
                                @click="toOrderComplete(scope.row)"
                            >
                                确认完成
                            </span>
                            <span
                                class="operation-item"
                                v-if="auth_control.have_confirm_complete_auth && (scope.row.order_status === '8' && scope.row.order_tag === '1')"
                                @click="refuseRejectClick(scope.row)"
                            >
                                完成
                            </span>
                            <span class="operation-item" @click="toOrderDetail(scope.row.uuid)" v-if="auth_control.have_detail_auth">详情</span>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <common-pagination :total="total" :page_size="page_size" @size-change="handelPagesizeChange" @page-change="handlePageChange"></common-pagination>
        </div>
        <common-dialog
            :title="dialogTitle"
            :dialogVisible="dialogVisible"
            :showClose="show_dialog_close"
            :showBtns="show_dialog_btns"
            @cancel="dialogCancelClick"
            @confirm="dialogConfirmClick"
            @dialog-close="dialogClose"
        >
            <div class="dialog-body-wrap">
                <div v-if="dialogType === 'auto_dispatch'" class="dispatch-wrap">
                    <el-input v-model="auto_dispatch_time.time" placeholder="请输入自动派单时间" class="dispatch_input"></el-input>
                    <span>分钟</span>
                    <div>备注: 到达{{ auto_dispatch_time.time }}分钟后, 系统将自动派单</div>
                </div>
                <div v-if="dialogType === 'remark'">
                    <div class="dialog-remark-color-wrap">
                        <span :class="{ red: true, remarks_box: true, color_selected: order_row.remarks_colour === '2' }" @click="colorClick('2')"></span>
                        <span :class="{ yellow: true, remarks_box: true, color_selected: order_row.remarks_colour === '1' }" @click="colorClick('1')"></span>
                        <span :class="{ green: true, remarks_box: true, color_selected: order_row.remarks_colour === '3' }" @click="colorClick('3')"></span>
                    </div>
                    <el-input type="textarea" placeholder="请输入文字" v-model="order_row.remarks" maxlength="500" show-word-limit :rows="10" class="remark-input"></el-input>
                </div>
                <div v-if="dialogType === 'dispatch_order'">
                    <el-select v-model="selected_salesman_uuid" placeholder="请选择业务员">
                        <el-option v-for="item in salesman_list" :key="item.uuid" :label="item.user_name" :value="item.uuid"></el-option>
                    </el-select>
                    <div class="commission_input-wrap">
                        <label for="commission_input" class="input-label">佣金比例：</label>
                        <el-input v-model="order_row.commission_rate" id="commission_input" placeholder="请输入佣金比例" class="commission_rate"></el-input>
                        <span>%</span>
                    </div>
                </div>
                <div v-if="dialogType === 'refound'">
                    是否退款？
                    <!-- <el-input type="number" v-model="refund_price" placeholder="请输入退款金额"></el-input> -->
                </div>
                <div v-if="dialogType === 'cancel_order'">
                    <el-radio-group v-model="cancel_resaon" class="radio-group">
                        <el-radio label="客户不愿意协商">客户不愿意协商</el-radio>
                        <el-radio label="无法联系客户">无法联系客户</el-radio>
                        <el-radio label="商家要求撤单">商家要求撤单</el-radio>
                        <el-radio label="other">其他原因</el-radio>
                    </el-radio-group>
                    <el-input
                        v-if="cancel_resaon === 'other'"
                        type="textarea"
                        placeholder="请输入文字"
                        v-model="cancel_order_input"
                        maxlength="100"
                        show-word-limit
                        :rows="4"
                        class="remark-input"
                    ></el-input>
                    <div class="img-wrap">
                        <label class="img-label">图片上传({{ reasons_for_cancellation_img.length }}/6)</label>
                        <imageUpload v-model="reasons_for_cancellation_img" :limit="6" />
                    </div>
                </div>
                <div v-if="dialogType === 'recall_order'">
					<li class="follow-wrap">
						<div v-for='(item,index) in followTag' :key="index" class="follow-tag" :class='item.tagFlag?"current":""' @click="selectItem(item)">{{item.name}}</div>
					</li>
                    <el-input type="textarea" placeholder="请详细描述撤回原因" v-model="withdraw_reasons" maxlength="100" show-word-limit :rows="4" class="remark-input"></el-input>
                    <div class="img-wrap">
                        <label class="img-label">图片上传({{ withdraw_reasons_img.length }}/6)</label>
                        <imageUpload v-model="withdraw_reasons_img" :limit="6" />
                    </div>
                </div>
                <div v-if="dialogType === 'refuse-refound'">是否拒绝退款？</div>
                <div v-if="dialogType === 'order_complete'">确认订单已完成？</div>
                <div v-if="dialogType === 'close_order'">确认关闭订单？</div>
                <div v-if="dialogType === 'refuse_reject'" class="refuse-wrap">
                    <el-input type="textarea" placeholder="请输入文字" v-model="reason_for_rejection" maxlength="100" show-word-limit :rows="4" class="remark-input"></el-input>
                    <div class="img-wrap">
                        <imageUpload v-model="img" :limit="6" />
                        <label>图片上传({{ img.length }}/6)</label>
                    </div>
                </div>
                <div v-if="dialogType === 'contact_remark'" class="refuse-wrap">
                    <el-input type="textarea" placeholder="请输入联系方式备注" v-model="order_row.order_remake" :rows="4" class="remark-input"></el-input>
                </div>
            </div>
        </common-dialog>



        <el-dialog title="请选择要恢复的端口"  height="200" width="30%" :visible.sync="dialogFormVisible">
            <el-form :model="form">
                <el-form-item label="">
                <el-checkbox-group v-model="form.type">
                    <el-checkbox :label="value.value"  v-for="value in typeList">{{ value.label}}</el-checkbox>
                </el-checkbox-group>
            </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisible = false">取 消</el-button>
                <el-button type="primary" @click="recallOrder">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import CommonPagination from '@/components/CommonPagination';
import CommonDialog from '@/components/CommonDialog';
import imageUpload from '@/components/ImageUpload';
import { mapState, mapMutations } from 'vuex';
import { orderlist, dispatchTime, putDispatchTime, changeorder, orderFollowRecord, exportOrder ,delOrders,recallOrders} from '@/api/order';
import { getQuickTagList } from '@/api/tag';
import utils from '@/jslibs/utils';
import axios from 'axios';
import baseUrl from '@/configs/baseUrl';

export default {
    name: 'orderlist',
    data() {
        return {
            dateValue: [], //开始时间和结束时间的数组
            selectted_project: '',
            service_project: [],
            keyword_search: '',
            order_type: '1',
            tableData: [],
            page_index: '1', //第几页
            page_size: '10',
            total: 0, //总条数
            dialogTitle: '',
            dialogVisible: false,
            dialogType: '', //auto_dispatch 自动派单，remark 备注，dispatch_order 派单 refound 退款， cancel_order 撤单
            auto_dispatch_time: {},
            selected_salesman_uuid: '',
            refund_price: '',
            cancel_resaon: '',
            cancel_order_input: '',
            order_row: {}, //当前编辑的订单
            order_follow_records: [],
            show_dialog_close: false,
            show_dialog_btns: true,
            auth_control: {
                //是否具有订单列表相应三级权限
                have_detail_auth: false,
                have_add_auth: false,
                have_export_auth: false,
                have_auto_dispatch_auth: false,
                have_remark_auth: false,
                have_follow_record_auth: false,
                have_widthdraw_order_auth: false,
                have_dispatch_order_auth: false,
                have_refound_auth: false,
                have_sucess_handle_auth: false,
                have_close_order_auth: false,
                have_confirm_complete_auth: false,
                have_delete_order_auth:false,
                have_recall_order_auth:false
            },
            folowRecordVisible: false,
            need_btns: false,
            salesman_uuid: '',
            search_value: '',
            reason_for_rejection: '',
            img: [], //拒绝驳回图片
            reasons_for_cancellation_img: [], //撤单图片
            withdraw_reasons_img: [], //撤回图片
            withdraw_reasons: '',
            exportUrl: '',
            dialogFormVisible:false,
            form:{
                type:[],
                uuid:'',
            },
            typeList:[],
			followTag:[
				"",
			],
        };
    },
    components: {
        CommonPagination,
        CommonDialog,
        imageUpload
    },
    computed: {
        ...mapState(['salesman_list', 'operationList', 'imgDomain'])
    },
    mounted() {
        let uuid = this.$route.query.uuid;
        if (uuid) {
            this.salesman_uuid = uuid;
        }
        this.getOrderList();
        this.getServiceList();
        this.getDispatchTime();
        this.handleThreeRules();
		 this.getCancelTagList();
    },
    methods: {
        ...mapMutations(['update_servicelist']),
        async getOrderList(args) {
            let start_time = this.dateValue.length ? this.dateValue[0] : '';
            let end_time = this.dateValue.length ? this.dateValue[1] : '';
            let postData = {
                order_type: this.order_type,
                page_index: this.page_index,
                page_size: this.page_size,
                start_time,
                end_time,
                keyword_search: this.keyword_search,
                salesman_uuid: this.salesman_uuid
            };
            const { data, status } = await orderlist(postData);
            if (status !== 200) return;
            this.tableData = data.data;
            this.total = data.total;
            console.log(data, '订单列表数据');
        },
		//获取情况备注
		async getCancelTagList(){
			let postData = {
			    tag_type: 'cancel'
			};
			const { data, status } = await getQuickTagList(postData);
			if (status !== 200) return
			this.followTag = data.data;
			this.followTag.forEach((item,index)=>{
				this.$set(item,"tagFlag",false)
			})
		},
		
		selectItem(item){
			if(!item.tagFlag){
				this.$set(item,"tagFlag",true);
				if(this.withdraw_reasons && this.withdraw_reasons.slice(-1)!=","){//手动输入没有输入逗号，则选择下个标签的时候前面要加上
					this.withdraw_reasons += ","+item.name+',';
				}else{
					this.withdraw_reasons += item.name+',';
				}
			}
			else{
				this.$set(item,"tagFlag",false);
				this.withdraw_reasons = this.withdraw_reasons.replace(item.name+',',"")
			}
		},
        async getServiceList() {
            const { data, status } = await servicelist();
            if (status !== 200) return;
            this.service_project = [{ server_name: '全部', uuid: '' }].concat(data.data);
            this.update_servicelist(data.data);
            console.log('服务列表', data);
        },
        searchOrder() {
            this.keyword_search = this.search_value;
            this.selectted_project = '';
            this.getOrderList();
        },
        selectChange() {
            this.keyword_search = this.selectted_project;
            this.getOrderList();
        },
        dateChange() {
            this.getOrderList();
        },
        orderTypeClick(type) {
            this.order_type = type;
            this.getOrderList();
        },
        async getDispatchTime() {
            const { data, status } = await dispatchTime();
            if (status !== 200) return;
            this.auto_dispatch_time = data;
        },
        handelPagesizeChange(size) {
            this.page_size = size;
            this.getOrderList();
        },
        handlePageChange(page) {
            this.page_index = page;
            this.getOrderList();
        },
        dialogCancelClick() {
            this.dialogVisible = false;
        },
        async dialogConfirmClick() {
            switch (this.dialogType) {
                case 'auto_dispatch':
                    if (this.auto_dispatch_time.time === '') {
                        this.$message('自动派单时间不能为空');
                        break;
                    }
                    const { status } = await putDispatchTime({ time: this.auto_dispatch_time.time }, this.auto_dispatch_time.id);
                    if (status === 200) this.dialogVisible = false;
                    this.$message({
                        type: 'success',
                        message: '设置成功'
                    });
                    break;
                case 'remark': {
                    const { remarks, remarks_colour } = this.order_row;
                    if (!remarks_colour || !remarks) {
                        this.$message('请选择备注颜色和输入备注内容');
                        break;
                    }
                    let postData = {
                        type: '7',
                        remarks,
                        remarks_colour
                    };
                    const { status } = await changeorder(postData, this.order_row.uuid);
                    if (status === 200) this.dialogVisible = false;
                    break;
                }
                case 'order_complete': {
                    const { status } = await changeorder({ type: '1' }, this.order_row.uuid);
                    if (status === 200) this.dialogVisible = false;
                    break;
                }
                case 'contact_remark': {
                    const { status } = await changeorder({ type: '10', order_remake: this.order_row.order_remake }, this.order_row.uuid);
                    if (status === 200) this.dialogVisible = false;
                    break;
                }
                case 'cancel_order': {
                    if ((this.cancel_resaon === 'other' && this.cancel_order_input === '') || !this.cancel_resaon) {
                        this.$message('撤单理由不能为空');
                        break;
                    }
                    let reasons_for_cancellation = this.cancel_resaon === 'other' ? this.cancel_order_input : this.cancel_resaon;
                    let postData = {
                        type: '2',
                        reasons_for_cancellation,
                        reasons_for_cancellation_img: this.reasons_for_cancellation_img
                    };
                    const { status } = await changeorder(postData, this.order_row.uuid);
                    if (status === 200) this.dialogVisible = false;
                    break;
                }
                case 'recall_order': {
                    if (!this.withdraw_reasons) {
                        this.$message('撤回理由不能为空');
                        break;
                    }

                    let postData = {
                        type: '15',
                        reasons_for_cancellation: this.withdraw_reasons,
                        reasons_for_cancellation_img: this.withdraw_reasons_img
                    };
                    const { status } = await changeorder(postData, this.order_row.uuid);
                    if (status === 200) this.dialogVisible = false;
                    break;
                }
                case 'refound':
                    console.log(this.order_row, 'order row');
                    {
                        // if (!this.refund_price) {
                        //   this.$message('退款金额不能为空');
                        //   break;
                        // }
                        // if (+this.refund_price > +this.order_row.order_total_price) {
                        //   this.$message('退款金额不能大于订单金额');
                        //   break;
                        // }
                        let postData = {
                            type: '6'
                            // refund_price: this.refund_price
                        };
                        const { status } = await changeorder(postData, this.order_row.uuid);
                        if (status === 200) this.dialogVisible = false;
                        break;
                    }
                case 'refuse-refound': {
                    let postData = {
                        type: '14'
                    };
                    const { status } = await changeorder(postData, this.order_row.uuid);
                    if (status === 200) this.dialogVisible = false;
                    break;
                }
                case 'dispatch_order': {
                    if (!this.selected_salesman_uuid || !this.order_row.commission_rate) {
                        this.$message('请选择业务员和输入提成比例');
                        break;
                    }
                    const { order_status } = this.order_row;
                    //待处理未分配业务员时 type为3 ，驳回、撤单时type 为4
                    let type = order_status === '2' ? '3' : '4';
                    let postData = {
                        type,
                        commission_rate: this.order_row.commission_rate / 100,
                        salesman_uuid: this.selected_salesman_uuid
                    };
                    const { status } = await changeorder(postData, this.order_row.uuid);
                    if (status === 200) this.dialogVisible = false;
                    this.selected_salesman_uuid = '';
                    break;
                    console.log(this.selected_salesman_uuid, this.order_row.commission_rate);
                }
                case 'succ_handled': {
                    const { status } = await changeorder({ type: '8' }, this.order_row.uuid);
                    if (status === 200) this.dialogVisible = false;
                    break;
                }
                case 'close_order': {
                    const { status } = await changeorder({ type: '5' }, this.order_row.uuid);
                    if (status === 200) this.dialogVisible = false;
                    break;
                }
                case 'refuse_reject': {
                    if (!this.reason_for_rejection) {
                        this.$message('拒绝理由不能为空');
                        break;
                    }
                    let postData = {
                        type: '9',
                        reason_for_rejection: this.reason_for_rejection,
                        img: this.img
                    };
                    const { status } = await changeorder(postData, this.order_row.uuid);
                    if (status === 200) this.dialogVisible = false;
                    break;
                }
            }
        },
        dialogClose() {
            this.dialogVisible = false;
            //每次关闭把dialog是否需要关闭按钮 和 是否需要确认取消按钮值重置
            this.show_dialog_close = false;
            this.folowRecordVisible = false;
            this.getOrderList();
        },
        autoDispatchOrderClick(row) {
            this.dialogType = 'auto_dispatch';
            this.dialogTitle = '自动派单设置';
            this.dialogVisible = true;
        },
        toRemarkClick(row) {
            this.order_row = JSON.parse(JSON.stringify(row));
            this.dialogType = 'remark';
            this.dialogTitle = '备注信息';
            this.dialogVisible = true;
            console.log(row, '订单行');
        },
        toContactRemark(row) {
            this.order_row = JSON.parse(JSON.stringify(row));
            this.dialogType = 'contact_remark';
            this.dialogTitle = '联系方式备注';
            this.dialogVisible = true;
        },
        colorClick(remarks_colour) {
            this.order_row.remarks_colour = remarks_colour;
        },
        dispatchOrderClick(row) {
            this.order_row = JSON.parse(JSON.stringify(row));
            this.order_row.commission_rate *= 100;
            this.dialogType = 'dispatch_order';
            this.dialogTitle = '派单';
            this.dialogVisible = true;
        },
        refoundClick(row) {
            this.order_row = JSON.parse(JSON.stringify(row));
            this.dialogType = 'refound';
            this.dialogTitle = '退款';
            this.dialogVisible = true;
        },
        refuseRefoundClick(row) {
            this.order_row = JSON.parse(JSON.stringify(row));
            this.dialogType = 'refuse-refound';
            this.dialogTitle = '拒绝退款';
            this.dialogVisible = true;
        },
        cancelOrderClick(row) {
            this.order_row = JSON.parse(JSON.stringify(row));
            this.dialogType = 'cancel_order';
            this.dialogTitle = '请选择撤单原因';
            this.dialogVisible = true;
        },
        recallOrderClick(row) {
            this.order_row = JSON.parse(JSON.stringify(row));
            this.dialogType = 'recall_order';
            this.dialogTitle = '请填写撤回原因';
            this.dialogVisible = true;
        },
        toOrderComplete(row) {
            this.order_row = JSON.parse(JSON.stringify(row));
            this.dialogType = 'order_complete';
            this.dialogTitle = '确认完成';
            this.dialogVisible = true;
        },
        refuseRejectClick(row) {
            this.order_row = JSON.parse(JSON.stringify(row));
            this.dialogType = 'refuse_reject';
            this.dialogTitle = '请输入拒绝驳回原因';
            this.dialogVisible = true;
        },
        delOrder(row){
          console.log(row.uuid);
          this.$confirm('此操作将永久删除该订单,不可恢复, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            delOrders(row.uuid);
            this.$message({
              type: 'success',
              message: '删除成功!'
            });
            this.getOrderList();

          }).catch(() => {
            /*this.$message({
              type: 'info',
              message: '已取消删除'
            });*/
          });
        },
        //撤销删除
        recallOrderDelete(row){
          this.form.type = [];
          if ( row.user_is_del == 2 && row.work_is_del == 2 ){
              this.typeList = [
                  {label:"用户端",value:"user"},
                  {label:"业务端",value:"work"},
              ];
          }else if (row.user_is_del == 2) {
              this.typeList = [{label:"用户端",value:"user"}];
          }else if (row.work_is_del == 2){
              this.typeList = [{label:"业务端",value:"work"}];
          }
          this.form.uuid = row.uuid;
          this.dialogFormVisible = true;

        },
        recallOrder(){
            if (!this.form.type.length){
                this.$message({
                    type: 'error',
                    message: '请选择要恢复的端口'
                });
                return ;
            }
            const obj ={
                type:this.form.type
            };
            this.dialogFormVisible = false;
            recallOrders(obj,this.form.uuid);
            this.$message({
                type: 'success',
                message: '恢复成功!'
            });
            this.getOrderList();
        },
        async toOrderFollowClick(row) {
            this.$router.push({
                path: '/order-list/order-record',
                query: {
                    uuid: row.uuid,
                    order_code: row.order_code
                }
            });
            // this.show_dialog_close = true;
            // this.dialogType = "order_follow_record";
            // this.dialogTitle = "订单跟进记录";
            // this.folowRecordVisible = true;
            // const { data, status } = await orderFollowRecord(
            //   { page_index: 1, page_size: 99 },
            //   row.uuid
            // );
            // //有数据时才更新store数据
            // this.order_follow_records = data.data;
        },
        succHandleClick(row) {
            this.order_row = JSON.parse(JSON.stringify(row));
            this.dialogType = 'succ_handled';
            this.dialogTitle = '成功处理';
            this.dialogVisible = true;
        },
        closeOrderClick(row) {
            this.order_row = JSON.parse(JSON.stringify(row));
            this.dialogType = 'close_order';
            this.dialogTitle = '关闭订单';
            this.dialogVisible = true;
        },
        toOrderDetail(uuid) {
            this.$router.push({
                path: '/order-list/order-detail',
                query: {
                    uuid
                }
            });
        },
        toAddOrder() {
            this.$router.push('/order-list/add-order');
        },
        handleThreeRules() {
            //处理三级权限
            console.log(this.operationList, 'operationList');
            let second_menu_name = this.$route.meta[1].name;
            this.operationList.forEach(item => {
                if (second_menu_name === item.name) {
                    this.three_rules = item.operations;
                }
            });
            this.three_rules.forEach(item => {
              console.log(item.menu_name);
                switch (true) {
                    case item.menu_name.indexOf('详情') !== -1:
                        this.auth_control.have_detail_auth = true;
                        break;
                    case item.menu_name.indexOf('新建') !== -1:
                        this.auth_control.have_add_auth = true;
                        break;
                    case item.menu_name.indexOf('导出') !== -1:
                        this.auth_control.have_export_auth = true;
                        break;
                    case item.menu_name.indexOf('自动派单') !== -1:
                        this.auth_control.have_auto_dispatch_auth = true;
                        break;
                    case item.menu_name.indexOf('备注') !== -1:
                        this.auth_control.have_remark_auth = true;
                        break;
                    case item.menu_name.indexOf('跟进记录') !== -1:
                        this.auth_control.have_follow_record_auth = true;
                        break;
                    case item.menu_name.indexOf('撤单') !== -1:
                        this.auth_control.have_widthdraw_order_auth = true;
                        break;
                    case item.id === 258:
                        this.auth_control.have_dispatch_order_auth = true;
                        break;
                    case item.menu_name.indexOf('退款') !== -1:
                        this.auth_control.have_refound_auth = true;
                        break;
                    case item.menu_name.indexOf('成功处理') !== -1:
                        this.auth_control.have_sucess_handle_auth = true;
                        break;
                    case item.menu_name.indexOf('关闭订单') !== -1:
                        this.auth_control.have_close_order_auth = true;
                        break;
                    case item.menu_name.indexOf('确认完成') !== -1:
                        this.auth_control.have_confirm_complete_auth = true;
                        break;
                   case item.menu_name.indexOf('订单删除') !== -1:
                        this.auth_control.have_delete_order_auth = true;
                        break;
                    case item.menu_name.indexOf('订单恢复') !== -1:
                        this.auth_control.have_recall_order_auth = true;
                        break;
                }
            });
        },
        exportOrderClick() {
            let start_time = this.dateValue.length ? this.dateValue[0] : '';
            let end_time = this.dateValue.length ? this.dateValue[1] : '';
            this.exportUrl = `${baseUrl}/v1/cms/OrderCvs?order_type=${this.order_type}&start_time=${start_time}&end_time=${end_time}&keyword_search=${
                this.keyword_search
            }&salesman_uuid=${this.salesman_uuid}`;
        }
    },

    filters:{
        filterPay(val){
            if (val != null){
                if(val.indexOf("支付") > -1){
                    return val.slice(0,-2);
                }
                else{
                    return val;
                }
            }else {
                return val;
            }
        }
    }
};
</script>

<style lang="less" scoped>
@import '~@/assets/styles/variables.less';

.operation-btns {
    text-align: right;
    margin-bottom: 30px;
    .exportBtn {
        display: inline-block;
        width: 110px;
        height: 40px;
        line-height: 40px;
        margin: 0 20px;
        text-align: center;
        cursor: pointer;
        text-decoration: none;
        color: #fff;
        background-color: #409eff;
        border-color: #409eff;
        border-radius: 4px;
    }
}
.filter-wrap {
    display: flex;
    .filter-item {
        margin-right: 20px;
    }
}
.searchInput {
    width: 200px;
    margin-right: 20px;
}
.order-type-wrap {
    margin-top: 20px;
    .order_type {
        color: rgba(153, 153, 153, 1);
        margin-right: 50px;
        cursor: pointer;
    }
    .active {
        font-weight: 500;
        color: rgba(76, 76, 76, 1);
    }
}
.table-wrap {
    margin-top: 30px;
    .remarks-wrap {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
    }
    .operation-wrap {
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        color: @color-text;
        .operation-item {
            cursor: pointer;
            margin-right: 5px;
        }
    }
}
.remarks_box {
    display: inline-block;
    width: 40px;
    height: 40px;
}
.yellow {
    background: yellow;
}
.red {
    background: red;
}
.green {
    background: green;
}
.dialog-body-wrap {
    text-align: center;
    .img-wrap {
        text-align: left;
    }
    .dispatch-wrap {
        .dispatch_input {
            width: 200px;
        }
    }
    .dialog-remark-color-wrap {
        display: flex;
        justify-content: space-around;
        margin-bottom: 20px;
    }
    .color_selected {
        border: 2px solid #000;
    }
    .commission_input-wrap {
        position: relative;
        margin-top: 20px;
        .input-label {
            display: block;
            position: relative;
            right: 62px;
        }
        .commission_rate {
            width: 186px;
        }
    }
    .radio-group {
        display: flex;
        flex-direction: column;
        text-align: left;
        /deep/.el-radio {
            line-height: 30px;
        }
    }
    .refuse-wrap {
        text-align: left;
        label {
            margin-left: 55px;
        }
    }
    .refuse_img {
        width: 80px !important;
        height: 80px !important;
    }
}

	.follow-wrap  .follow-tag{display: inline-block;padding: 4px 8px 5px 4px;margin-bottom: 5px;margin-right: 5px;;border-radius:3px;border:1px solid rgba(174,174,174,1);color:rgba(174,174,174,1);font-weight:400;font-size: 12px;}
	.follow-wrap .current{border:1px solid rgba(65,132,244,0.5);background:rgba(65,132,244,0.1);color:rgba(65,132,244,1);}
	.follow-detail{padding-bottom: 10px;font-size:14px;font-family:PingFangSC-Regular,PingFang SC;font-weight:400;color:rgba(20,20,20,1);}
	.follow-detail span{font-size:12px;font-family:PingFangSC-Regular,PingFang SC;font-weight:400;color:rgba(174,174,174,1);}
</style>
